import { CommandItem } from './types';
import { routes } from '../../routes';
import { managerRoutes } from '../../manager/routes';

type RegistryEntry = Omit<CommandItem, 'onSelect'> & {
  route: string;
};

const gotoItems: RegistryEntry[] = [
  {
    id: 'goto-dashboard',
    type: 'goto',
    label: 'Dashboard',
    icon: 'phosphor-house',
    keywords: ['home', 'overview', 'main'],
    route: routes.home.route.template(),
  },
  {
    id: 'goto-my-absences',
    type: 'goto',
    label: 'My Absences',
    icon: 'phosphor-airplane-tilt',
    keywords: ['leave', 'vacation', 'pto', 'holiday', 'time off', 'absence'],
    route: routes.myAbsences.route.template(),
  },
  {
    id: 'goto-absences-calendar',
    type: 'goto',
    label: 'Absences Calendar',
    icon: 'phosphor-calendar-blank',
    keywords: ['leave', 'vacation', 'calendar', 'team', 'absence'],
    route: routes.absencesCalendar.route.template(),
  },
  {
    id: 'goto-team-calendar',
    type: 'goto',
    label: 'Team Calendar',
    icon: 'phosphor-calendar-blank',
    keywords: ['team', 'calendar', 'schedule', 'absence'],
    route: routes.teamCalendar.route.template(),
  },
  {
    id: 'goto-time-tracking',
    type: 'goto',
    label: 'Time Tracking',
    icon: 'phosphor-clock',
    keywords: ['time', 'tracking', 'hours', 'timesheet'],
    route: routes.timeTracking.route.template(),
  },
  {
    id: 'goto-personal-data',
    type: 'goto',
    label: 'Personal Data',
    icon: 'phosphor-user',
    keywords: ['profile', 'personal', 'data', 'my data', 'info'],
    route: routes.personalData.route.template(),
  },
  {
    id: 'goto-documents-personal',
    type: 'goto',
    label: 'My Documents',
    icon: 'phosphor-file-text',
    keywords: ['documents', 'files', 'personal', 'payslip', 'contract'],
    route: routes.documentsPersonal.route.template(),
  },
  {
    id: 'goto-documents-company',
    type: 'goto',
    label: 'Company Documents',
    icon: 'phosphor-folder-simple',
    keywords: ['documents', 'files', 'company', 'policy', 'handbook'],
    route: routes.documentsCompany.route.template(),
  },
  {
    id: 'goto-goals',
    type: 'goto',
    label: 'Goals',
    icon: 'phosphor-target',
    keywords: ['goals', 'objectives', 'okr', 'targets', 'performance'],
    route: routes.performanceReviewGoals.route.template(),
  },
  {
    id: 'goto-performance-review',
    type: 'goto',
    label: 'Performance Review',
    icon: 'phosphor-trend-up',
    keywords: ['performance', 'review', 'feedback', 'evaluation', 'appraisal'],
    route: routes.performanceReview.route.template(),
  },
  {
    id: 'goto-workflows',
    type: 'goto',
    label: 'Workflows',
    icon: 'phosphor-flow-arrow',
    keywords: ['workflows', 'onboarding', 'offboarding', 'tasks', 'checklist'],
    route: routes.workflowsMeWorkflows.route.template(),
  },
  {
    id: 'goto-expenses',
    type: 'goto',
    label: 'My Expenses',
    icon: 'phosphor-receipt',
    keywords: ['expenses', 'reimbursement', 'receipt', 'cost'],
    route: routes.myExpenses.route.template(),
  },
  {
    id: 'goto-org-chart',
    type: 'goto',
    label: 'Org Chart',
    icon: 'phosphor-buildings',
    keywords: [
      'org chart',
      'organization',
      'hierarchy',
      'structure',
      'reporting',
    ],
    route: routes.orgChart.route.template(),
  },
  {
    id: 'goto-directory',
    type: 'goto',
    label: 'People Directory',
    icon: 'phosphor-users',
    keywords: [
      'directory',
      'people',
      'employees',
      'colleagues',
      'team',
      'contacts',
    ],
    route: routes.peopleDirectory.route.template(),
  },
  {
    id: 'goto-announcements',
    type: 'goto',
    label: 'Announcements',
    icon: 'phosphor-megaphone',
    keywords: ['announcements', 'news', 'updates', 'company news'],
    route: routes.announcements.route.template(),
  },
  {
    id: 'goto-engagement-surveys',
    type: 'goto',
    label: 'Engagement Surveys',
    icon: 'phosphor-heart',
    keywords: [
      'engagement',
      'survey',
      'enps',
      'satisfaction',
      'pulse',
      'feedback',
    ],
    route: routes.performanceReviewEngagementSurveys.route.template(),
  },
  {
    id: 'goto-skills',
    type: 'goto',
    label: 'Skills',
    icon: 'phosphor-lightning',
    keywords: ['skills', 'competencies', 'abilities'],
    route: routes.performanceReviewSkills.route.template(),
  },
  {
    id: 'goto-celebrations',
    type: 'goto',
    label: 'Celebrations',
    icon: 'phosphor-confetti',
    keywords: [
      'celebrations',
      'kudos',
      'recognition',
      'birthday',
      'anniversary',
      'cheer',
      'shoutout',
      'appreciation',
    ],
    route: routes.celebrationsFeed.route.template(),
  },
  {
    id: 'goto-certificates',
    type: 'goto',
    label: 'Certificates',
    icon: 'phosphor-certificate',
    keywords: ['certificates', 'certifications', 'training'],
    route: routes.myCertificates.route.template(),
  },
  {
    id: 'goto-approval-requests',
    type: 'goto',
    label: 'Approval Requests',
    icon: 'phosphor-check-circle',
    keywords: ['approvals', 'requests', 'pending', 'approve'],
    route: routes.pendingApprovalRequests.route.template(),
  },
  {
    id: 'goto-settings',
    type: 'goto',
    label: 'Settings',
    icon: 'phosphor-gear',
    keywords: ['settings', 'preferences', 'configuration', 'notifications'],
    route: routes.general.route.template(),
  },
  {
    id: 'goto-support',
    type: 'goto',
    label: 'Support',
    icon: 'phosphor-lifebuoy',
    keywords: ['support', 'help', 'ticket', 'helpdesk'],
    route: routes.tickets.route.template(),
  },
  {
    id: 'goto-inventory',
    type: 'goto',
    label: 'Inventory',
    icon: 'phosphor-briefcase',
    keywords: ['inventory', 'assets', 'equipment', 'devices'],
    route: routes.inventory.route.template(),
  },
  {
    id: 'goto-learning',
    type: 'goto',
    label: 'Learning',
    icon: 'phosphor-book-open',
    keywords: ['learning', 'courses', 'training', 'lms', 'education'],
    route: routes.performanceReviewLearning.route.template(),
  },
  {
    id: 'goto-projects',
    type: 'goto',
    label: 'Projects',
    icon: 'phosphor-kanban',
    keywords: ['projects', 'project tracking', 'timesheets'],
    route: routes.projectsOverview.route.template(),
  },
  {
    id: 'goto-shifts',
    type: 'goto',
    label: 'Shifts',
    icon: 'phosphor-clock',
    keywords: ['shifts', 'schedule', 'shift planner', 'roster'],
    route: routes.allShifts.route.template(),
  },
  {
    id: 'goto-request-forms',
    type: 'goto',
    label: 'Request Forms',
    icon: 'phosphor-clipboard-text',
    keywords: ['request', 'forms', 'change request', 'data change'],
    route: routes.requestForms.route.template(),
  },
];

const actionItems: RegistryEntry[] = [
  {
    id: 'action-request-absence',
    type: 'action',
    label: 'Request an absence',
    icon: 'phosphor-airplane-tilt',
    keywords: ['leave', 'vacation', 'pto', 'request', 'absence', 'time off'],
    route: routes.myAbsences.route.template() + '?action=request',
  },
  {
    id: 'action-see-absences',
    type: 'action',
    label: 'See my absences',
    icon: 'phosphor-airplane-tilt',
    keywords: ['leave', 'vacation', 'pto', 'absence', 'my absences'],
    route: routes.myAbsences.route.template(),
  },
  {
    id: 'action-track-time',
    type: 'action',
    label: 'Track my time',
    icon: 'phosphor-clock',
    keywords: ['time', 'clock in', 'start', 'tracking', 'timer'],
    route: routes.timeTracking.route.template(),
  },
  {
    id: 'action-view-documents',
    type: 'action',
    label: 'View my documents',
    icon: 'phosphor-file-text',
    keywords: ['documents', 'payslip', 'salary', 'pay', 'contract', 'files'],
    route: routes.documentsPersonal.route.template(),
  },
  {
    id: 'action-submit-expense',
    type: 'action',
    label: 'Submit an expense',
    icon: 'phosphor-receipt',
    keywords: ['expense', 'reimbursement', 'receipt', 'submit'],
    route: routes.myExpenses.route.template(),
  },
  {
    id: 'action-edit-profile',
    type: 'action',
    label: 'Edit my profile',
    icon: 'phosphor-user',
    keywords: ['edit', 'profile', 'personal data', 'update', 'info'],
    route: routes.personalData.route.template(),
  },
  {
    id: 'action-view-goals',
    type: 'action',
    label: 'View my goals',
    icon: 'phosphor-target',
    keywords: ['goals', 'objectives', 'okr', 'targets'],
    route: routes.performanceReviewGoals.route.template(),
  },
  {
    id: 'action-check-team',
    type: 'action',
    label: 'Check my team',
    icon: 'phosphor-users-three',
    keywords: ['team', 'reports', 'direct reports', 'manager'],
    route: managerRoutes.myTeamOverview.route.template(),
  },
  {
    id: 'action-send-cheer',
    type: 'action',
    label: 'Send a cheer',
    icon: 'phosphor-confetti',
    keywords: [
      'cheer',
      'kudos',
      'recognition',
      'appreciation',
      'celebrate',
      'shoutout',
      'thank',
      'thanks',
    ],
    route: routes.celebrationsFeed.route.template() + '?action=cheer',
  },
];

export function getStaticRegistryItems(): RegistryEntry[] {
  return [...actionItems, ...gotoItems];
}

export function getRegistryItemById(id: string): RegistryEntry | undefined {
  return [...actionItems, ...gotoItems].find((item) => item.id === id);
}

export function getRouteForItem(item: RegistryEntry): string {
  return item.route;
}
